import React from 'react';
import { IconProps } from '../types';

export const ITIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M11 19C12.6569 19 14 17.6569 14 16C14 14.3431 12.6569 13 11 13C9.34315 13 8 14.3431 8 16C8 17.6569 9.34315 19 11 19Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M5 28C5 24.686 7.686 22 11 22C14.314 22 17 24.686 17 28"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path d="M13 7H1V28H28V16" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
        <path
            d="M17 3V10C17 11.105 17.895 12 19 12H20V15L25 12H29C30.105 12 31 11.105 31 10V3C31 1.895 30.105 1 29 1H19C17.895 1 17 1.895 17 3Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);
